import { useRef, useState } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import { Link, useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert"; 
import "react-confirm-alert/src/react-confirm-alert.css";
import { ToastContainer,toast } from "react-toastify";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import Select from "react-select";
import _ from "lodash";

import authHeader from "../../../services/auth-header";
import { API } from "../../../backend";
import { getTrans as t } from "../../../Localization/translations";
import Helper from "../../../Helper";
import TaxRatesService from "../../../services/accounting/taxrateService";

function TaxRates() {
  let navigate = useNavigate();

  const [zipcode, setZipcode] = useState("");

  const tableRef = useRef();

  const [permissionss, setPermission] = useState(
    localStorage.getItem("permissions")
  );
  const permissionsArray = permissionss.split(",");
  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const [selectedValue2, setSelectedValue2] = useState("");

  const [isLoading2, setIsLoading2] = useState(false);
  const [inputvalue, setValue] = useState("");
  const [currentPage2, setCurrentPage2] = useState(1);
  const [options2, setOptions2] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const handelInputChange = (value) => {
    setValue(value);
    setCurrentPage2(1);
    setOptions2([]);
    loadOptions(value, 1);
  };

  const handleMenuScrollToBottomName = () => {
    loadOptions(inputvalue, currentPage2);
  };

  const handelChange = (value) => {
    setSelectedValue(value);
  };

  const loadOptions = async (value, page) => {
    try {
      if (value !== "") {
        setIsLoading2(true);
        const response = await fetch(
          `${API}helper/ajax/load-allstates/?state_name=${value}&page=${page}`,
          { headers: authHeader() }
        );
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data;

          setOptions2((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage2((prevPage) => prevPage + 1);
        } else {
          console.error("No data received or empty array from API.");
        }
        setIsLoading2(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading2(false);
    }
  };

  const handleEdit = (id) => {
    navigate("/edittaxrates", { state: id });
  };

  const handelSearch = () => {
    tableRef.current.onQueryChange();
  };
  const handleClear = () => {
    setSelectedValue(null);
    setSelectedValue2("");
    setZipcode("");

    tableRef.current.onQueryChange();
  };

  const handleView = (id) => {
    navigate("/taxrate", { state: id });
  };

  const handelDelete = (id) => {
    confirmAlert({
      title: "",
      message: "Are you sure you want to delete this Tax Rate?.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            TaxRatesService.TaxRateDelete(id).then((response) => {
              if (response.data.success) {
                toast.success(`${response.data.response}`, {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
                tableRef.current.onQueryChange();
              } else {
                toast.error(`${response.data.error}`, {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              }
            });
          },
        },
        {
          label: "No",
        },
      ],
    });
  };
  return (
    <div className="container-fluid  ">
      <div className="row ">
        <ToastContainer />
        <div className="col-md-12">
          <div className=" mb-0">
            <div className="header pb-0">
              <div className="d-lg-flex"></div>
            </div>
            <div className="body">
              <div className="p-0">
                <MaterialTable
                  tableRef={tableRef}
                  style={{
                    padding: "0.5rem 0.5rem",
                    backgroundColor: "var(--bs-table-bg)",
                    borderBottomWidth: "1px",
                    boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                  }}
                  title={<h5 className="d-lg-flex">{t("Tax Rates")}</h5>}
                  columns={[
                    {
                      title: `${t("State")}`,
                      field: "state_name",
                      editable: "never",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("State")}
                          </div>
                          <div
                            className="hyperlink"
                            onClick={() => handleView(rowData.id)}
                          >
                            {rowData.state_name}
                          </div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Zip Code")}`,
                      field: "zip",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("Zip Code")}
                          </div>
                          <div>{rowData.zip}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Tax Region")}`,
                      field: "tax_region",
                      //   lookup: ENABLED,
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("Tax Region")}
                          </div>
                          <div>{rowData.tax_region}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Combined Rate")}`,
                      field: "combined_rate",
                      //   lookup: ENABLED,
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("Combined Rate")}
                          </div>
                          <div>{Helper.TaxRateAmount(rowData.combined_rate)}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("State Rate")}`,
                      field: "state_rate",
                      //   lookup: ENABLED,
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("State Rate")}
                          </div>
                          <div>{Helper.TaxRateAmount(rowData.state_rate)}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("County Rate")}`,
                      field: "county_rate",
                      //   lookup: ENABLED,
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("County Rate")}
                          </div>
                          <div>{Helper.TaxRateAmount(rowData.county_rate)}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("City Rate")}`,
                      field: "city_rate",
                      //   lookup: ENABLED,
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("City Rate")}
                          </div>
                          <div>{Helper.TaxRateAmount(rowData.city_rate)}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Special Rate")}`,
                      field: "special_rate",
                      //   lookup: ENABLED,
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("Special Rate")}
                          </div>
                          <div>{Helper.TaxRateAmount(rowData.special_rate)}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Start Date")}`,
                      field: "start_date",
                      //   lookup: ENABLED,
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("Start Date")}
                          </div>
                          <div>
                            {rowData.start_date
                              ? Helper.DateNormal(rowData.start_date)
                              : "None"}
                          </div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("End Date")}`,
                      field: "end_date",
                      //   lookup: ENABLED,
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("End Date")}
                          </div>
                          <div>
                            {rowData.end_date
                              ? Helper.DateNormal(rowData.end_date)
                              : "None"}
                          </div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                  ]}
                  data={(query) =>
                    new Promise((resolve, reject) => {
                      const { orderBy, orderDirection } = query;
                      let state_name = "";
                      let zip_code_name = "";
                      if (selectedValue && zipcode) {
                        state_name = selectedValue.name;
                        zip_code_name = zipcode;
                      } else if (selectedValue) {
                        state_name = selectedValue.name;
                      } else if (zipcode) {
                        zip_code_name = zipcode;
                      }

                      let url = API + "accounting/tax-rate-view/?";
                      url += `state_name=${
                        state_name !== "" ? state_name : ""
                      }`;
                      url += `&zip_code=${
                        zip_code_name !== "" ? zip_code_name : ""
                      }`;
                      url += "&per_page=" + query.pageSize;
                      url += "&page=" + (query.page + 1);
                      url += "&search=" + query.search;

                      if (orderBy) {
                        url += `&orderBy=${orderBy.field}`;
                        url += `&orderDirection=${orderDirection}`;
                      }
                      fetch(url, { headers: authHeader() })
                        .then((response) => response.json())
                        .then((result) => {
                          resolve({
                            data:
                              query.orderBy && query.orderDirection
                                ? _.orderBy(
                                    result.data,
                                    [query.orderBy.field],
                                    [query.orderDirection]
                                  )
                                : result.data,
                            page: result.page - 1,
                            totalCount: result.total,
                          });
                        });
                    })
                  }
                  actions={[
                    {
                      icon: () =>
                        permissionss &&
                        permissionsArray.includes("change_itemmaster") ===
                          true ? (
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/static/images/ic-edit.svg"
                            }
                            alt="edit"
                          />
                        ) : (
                          ""
                        ),
                      tooltip: "Edit",
                      onClick:
                        permissionss &&
                        permissionsArray.includes("change_itemmaster") === true
                          ? (event, rowData) => {
                              handleEdit(rowData.id);
                            }
                          : "",
                    },
                    {
                      icon: () => (
                        permissionss &&  permissionsArray.includes('delete_itemmaster')===true ?
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/static/images/ic-delete.svg"
                          }
                          alt="delete"
                        />:""
                      ),
                      tooltip: "Delete",
                      onClick: permissionss &&  permissionsArray.includes('delete_itemmaster')===true ? (event, rowData) => {
                        handelDelete(rowData.id);
                      }:"",
                    },
                  ]}
                  //   editable={{
                  //     onRowUpdate: permissionss && permissionsArray.includes('change_accounts') === true ? (newData, oldData) =>
                  //       new Promise((resolve, reject) => {
                  //         const updatedStatusData = {
                  //           active: newData.active,
                  //           account_number: newData.account_number
                  //         };
                  //         axios
                  //           .post(
                  //             API + `accounting/tax-rate-view/`,
                  //             { headers: authHeader() }
                  //           )
                  //           .then((response) => {
                  //             const dataUpdate = [...data];
                  //             const index = oldData.tableData.id;
                  //             dataUpdate[index] = {
                  //               ...oldData,
                  //               ...updatedStatusData,
                  //             };
                  //             setData([...dataUpdate]);
                  //             resolve();
                  //           })
                  //           .catch((error) => {
                  //             reject();
                  //           });
                  //       }) : "",
                  //   }}
                  components={{
                    Toolbar: (props) => (
                      <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class">
                        <MTableToolbar {...props} />
                        <span
                          onClick={() => setState({ isPaneOpen: true })}
                          style={{
                            color: "#b4b7c5",
                            paddingRight: "1px",
                            cursor: "pointer",
                          }}
                        >
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/static/images/ic-filter.svg"
                            }
                            alt="filter"
                          />
                        </span>
                        {
                          // permissionss &&  permissionsArray.includes('add_itemmaster')===true ?
                          // customerPermission !== 'Customer' &&
                          <Link className="navbar-brand m-0" to="/addtaxrates">
                            <button
                              className="add-party add btn btn-primary  mb-0"
                              id="add-task"
                            >
                              +&nbsp; {t("Add Rate")}
                            </button>
                          </Link>
                          // :""
                        }
                      </div>
                    ),
                    // Container: (props) => (
                    //   <div id="Payment">
                    //     <Paper {...props} />
                    //   </div>
                    // ),
                  }}
                  options={{
                    headerStyle: {
                      backgroundColor: "white",
                      color: "#245C7F",
                      fontSize: 12,
                    },
                    rowStyle: (rowData, index) => {
                      if (index % 2) {
                        return { backgroundColor: "#fff" };
                      }
                    },
                    sorting: true,
                    search: true,
                    toolbar: true,
                    paging: true,
                    pageSize: 10, // make initial page size
                    emptyRowsWhenPaging: false, // To avoid of having empty rows
                    pageSizeOptions: [10, 15, 20, 50],
                    paginationType: "stepped",
                    showFirstLastPageButtons: false,
                    actionsColumnIndex: -1,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <SlidingPane
        className="some-custom-class"
        overlayClassName="some-custom-overlay-class"
        isOpen={state1.isPaneOpen}
        title="Filter By"
        subtitle=""
        onRequestClose={() => {
          setState({ isPaneOpen: false });
        }}
      >
        <div className="col-xl-12">
          <div className="form-group row">
            <label className="col-lg-12 col-form-label">{t("State")}</label>
            <div className="col-lg-12">
              <Select
                value={selectedValue}
                filterOption={false}
                options={options2}
                isClearable
                onInputChange={handelInputChange}
                getOptionLabel={(options) => options.name}
                getOptionValue={(options) => options.id}
                isLoading={isLoading2}
                placeholder={t("Search for State(%for All)")}
                onMenuScrollToBottom={handleMenuScrollToBottomName}
                onChange={handelChange}
              />
            </div>
          </div>
          <label className="col-lg-12 col-form-label">{t("Zip")}</label>
          <div className="">
            <input
              className="form-control"
              placeholder="Zip"
              value={zipcode}
              onChange={(e) => setZipcode(e.target.value)}
            />
          </div>
        </div>
        <div className="col-xl-12">
          <div className="form-group row">
            <div className="col-lg-12 text-left" style={{ marginTop: "30px" }}>
              <button
                type="button"
                className="clearReceipt btn bg-gradient-secondary btn-m ms-auto mb-0"
                onClick={handleClear}
              >
                {t("Reset")}
              </button>
              &nbsp;&nbsp;
              <button
                type="button"
                className="filter add btn btn-primary btn-m ms-auto mb-0"
                onClick={handelSearch}
              >
                {t("Apply")}
              </button>
              &nbsp;&nbsp;
            </div>
          </div>
        </div>
      </SlidingPane>
    </div>
  );
}

export default TaxRates;
